<div class="status-container"
  layout="row"
  layout-align="space-between center"
  flex>
  @if (isAuthorized) {
    <button class="status-block trigger margin-right"
      mat-button
      (menuOpened)="statusMenuOpened()"
      [ngClass]="clientStatusStyleMap[clientStatus.name]?.class"
      [matMenuTriggerFor]="statusMenu">
      <span layout="row"
        layout-align="space-between center">
        <mat-icon class="status-icon">{{ clientStatusStyleMap[clientStatus.name]?.icon }}</mat-icon>
        @if (clientStatus.id) {
          <span class="status-name"
          flex>{{ (clientStatus | clientStatusToTranslation).name.toUpperCase() }}</span>
        }
        @if (!clientStatus.id) {
          <span [translate]="'clients.selectClientStatus'"></span>
        }
        <mat-icon>keyboard_arrow_down</mat-icon>
      </span>
    </button>
    @if (shouldShowReasonTrigger()) {
      <button class="status-block right-padding-fix status-reason"
        (menuOpened)="reasonMenuOpened()"
        [matMenuTriggerFor]="reasonMenu"
        mat-button
        >
        <span layout="row"
          layout-align="space-between center">
          <span>{{ (clientStatus | clientStatusToTranslation).reason }}</span>
          <mat-icon>keyboard_arrow_down</mat-icon>
        </span>
      </button>
    }
  } @else {
    <div class="status-block disabled margin-right"
      [ngClass]="clientStatusStyleMap[clientStatus.name]?.class">
      <span layout="row"
        layout-align="space-between center">
        <mat-icon class="status-icon">{{ clientStatusStyleMap[clientStatus.name]?.icon }}</mat-icon>
        <span class="status-name"
        flex>{{ (clientStatus | clientStatusToTranslation).name.toUpperCase() }}</span>
      </span>
    </div>
    @if (shouldShowReasonTrigger()) {
      <div class="status-block disabled status-reason"
        mat-button
        >
        <span layout="row"
          layout-align="center center">
          <span>{{ (clientStatus | clientStatusToTranslation).reason }}</span>
        </span>
      </div>
    }
  }

</div>

<mat-menu #statusMenu="matMenu"
  class="client-status-menu"
  [overlapTrigger]="false">
  @for (status of menuStatuses; track status) {
    <button class="status-block"
      mat-menu-item
      [ngClass]="clientStatusStyleMap[status.name]?.class"
      (click)="selectedStatusChanged(status)">
      <mat-icon class="status-icon">{{ clientStatusStyleMap[status.name]?.icon }}</mat-icon>
      <span class="status-name">{{ (status | clientStatusToTranslation).name.toUpperCase() }}</span>
    </button>
  }
</mat-menu>

<mat-menu #reasonMenu="matMenu"
  [overlapTrigger]="false">
  <div layout="column"
    layout-align="start stretch">
    @for (status of currentReasons; track status) {
      <button class="status-block"
        mat-menu-item
        (click)="selectedStatusChanged(status)"
        >
        <span>
          {{ ('global.' + status.reason.toLowerCase() | translate) }}
        </span>
      </button>
    }
  </div>
</mat-menu>
